import React, { useEffect, useState } from "react"
import MetaTags from "react-meta-tags"
import queryString from "query-string"
import { useLocation, withRouter } from "react-router-dom"
import { Container, Row, Col, Card, CardBody, Collapse } from "reactstrap"
import ContainerCollapse from "components/Common/ContainerCollapse"
import Lightbox from "react-image-lightbox"
import "react-image-lightbox/style.css"

import { useDispatch, useSelector } from "react-redux"
import { getTracking, resetTrackingData } from "store/actions"

import classnames from "classnames"

const TrackingView = props => {
  const dispatch = useDispatch()
  const location = useLocation()
  const params = queryString.parse(location.search)
  const { tracking } = useSelector(state => ({
    tracking: state.Trackings.tracking,
  }))

  const [photoIndex, setphotoIndex] = useState(0)
  const [isGallery, setisGallery] = useState(false)
  const [images, setImages] = useState([])
  const [collapse, setCollapse] = useState(true)

  useEffect(() => {
    dispatch(resetTrackingData())
    dispatch(getTracking("", params.bookingNo || "", params.containerNo || ""))
  }, [])

  useEffect(() => {
    if (tracking && tracking.images && tracking.images.length > 0)
      setImages([...tracking.images])
    else setImages([])
  }, [tracking])

  function imageName(imgUrl) {
    const url = imgUrl.split("/")
    const name = url[url.length - 1].split(".")
    return name[0]
  }

  return (
    <React.Fragment>
      {isGallery ? (
        <Lightbox
          mainSrc={images[photoIndex].image_display}
          nextSrc={images[(photoIndex + 1) % images.length].image_thumb}
          prevSrc={
            images[(photoIndex + images.length - 1) % images.length].image_thumb
          }
          enableZoom={true}
          onCloseRequest={() => {
            setisGallery(false)
          }}
          onMovePrevRequest={() => {
            setphotoIndex((photoIndex + images.length - 1) % images.length)
          }}
          onMoveNextRequest={() => {
            setphotoIndex((photoIndex + 1) % images.length)
          }}
          imageCaption={imageName(images[photoIndex].image_display)}
        />
      ) : null}

      <div className="page-content">
        <MetaTags>
          <title>Hast | View Tracking</title>
        </MetaTags>
        <Container fluid>
          <div className="d-flex flex-wrap mt-2 mb-3">
            <div className="col-8">
              <div className="d-inline-block">
                <h4 className="">View Tracking</h4>
              </div>
            </div>
          </div>
          {tracking && (
            <>
              <section id="header-section">
                <Row>
                  <Col xs="6" sm="3" md="2">
                    <span className="font-weight-light">Booking No.</span>
                    <h4 className="font-size-16">
                      {tracking.booking_no || ""}
                    </h4>
                  </Col>
                  <Col xs="6" sm="3" md="2">
                    <span className="font-weight-light">Container No.</span>
                    <h4 className="font-size-16">
                      {tracking.container_no || ""}
                    </h4>
                  </Col>
                  <Col xs="6" sm="3" md="2">
                    <span className="font-weight-light">Type</span>
                    <h4 className="font-size-16">
                      <small
                        style={{
                          width: "50px",
                        }}
                        className={classnames("badge py-2", {
                          "bg-success": tracking.type === "in",
                          "bg-warning": tracking.type === "out",
                        })}
                      >
                        {tracking.type.toUpperCase()}
                      </small>
                    </h4>
                  </Col>
                </Row>
              </section>
              <section id="container-info-section">
                <ContainerCollapse containerInfo={tracking.containerInfo} />
              </section>
              <section id="images-section">
                <h4 className="font-size-16 mt-4 ">
                  Images {images.length > 0 && ` (${images.length})`}
                </h4>
                {images.length === 0 && (
                  <Row>
                    <span>No Image Uploaded.</span>
                  </Row>
                )}
                {images.length > 0 && (
                  <>
                    <div className="popup-gallery d-flex flex-wrap mt-4">
                      <Row className="w-100">
                        {images.map((img, index) => (
                          <Col xl="3" sm="6" key={img.uid}>
                            <Card
                              className="text-center"
                              style={{ width: "100%" }}
                            >
                              <CardBody>
                                <img
                                  className=""
                                  style={{ width: "100%", cursor: "pointer" }}
                                  src={img.image_thumb}
                                  alt={imageName(img.image_thumb)}
                                  onClick={() => {
                                    setisGallery(true)
                                    setphotoIndex(index)
                                  }}
                                />
                                <Row className="m-0 mt-2">
                                  <Col
                                    className="text-center p-0"
                                    style={{
                                      wordWrap: "break-word",
                                      wordBreak: "break-all",
                                    }}
                                  >
                                    {imageName(img.image_thumb)}
                                  </Col>
                                </Row>
                              </CardBody>
                            </Card>
                          </Col>
                        ))}
                      </Row>
                    </div>
                  </>
                )}
              </section>
            </>
          )}

          {!tracking && (
            <Row className="text-center">
              <Col>Not found data.</Col>
            </Row>
          )}
        </Container>
      </div>
    </React.Fragment>
  )
}

export default withRouter(TrackingView)
